import { isBefore } from 'date-fns'

import { RANGE_DAY } from './date-picker.constants'

export function calculateNewRange(newValue, range, rangeDay, setRangeDay) {
  const newDate = new Date(newValue)
  newDate.setHours(0, 0, 0, 0)

  let newRange

  if (!range || range.length === 0) {
    newRange = [new Date(newDate), new Date(newDate)]
  } else {
    const [start, end] = range

    if (isBefore(newDate, start)) {
      newRange = [new Date(newDate), new Date(end)]
    } else if (newDate > end) {
      newRange = [new Date(start), new Date(newDate)]
    } else {
      newRange = [new Date(newDate), new Date(newDate)]
    }
  }
  newRange[0].setHours(0, 0, 0, 0)
  newRange[1].setHours(23, 59, 59, 999)

  setRangeDay(rangeDay === RANGE_DAY.FIRST ? RANGE_DAY.LAST : RANGE_DAY.FIRST)

  return newRange
}
